import actions from './actions';
import mutations from './mutations';

const state = {
  products: [],
  mall_product_list: [],
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
